import { z } from 'zod';
export const snowplowFocusFormEventSchemaV1 = z
    .object({
    formId: z.string().min(0).max(4096).describe('The id of the form the element belongs to'),
    elementId: z.string().min(0).max(4096).describe('The id of the element that has just received focus'),
    nodeName: z.enum(['INPUT', 'TEXTAREA', 'SELECT']).describe('The node type of the element'),
    elementType: z
        .enum([
        'button',
        'checkbox',
        'color',
        'date',
        'datetime',
        'datetime-local',
        'email',
        'file',
        'hidden',
        'image',
        'month',
        'number',
        'password',
        'radio',
        'range',
        'reset',
        'search',
        'submit',
        'tel',
        'text',
        'time',
        'url',
        'week',
    ])
        .describe('The type of input element')
        .optional(),
    elementClasses: z
        .union([
        z
            .array(z.string().min(0).max(4096).describe('A class on the element'))
            .describe('An array of the classes on the element'),
        z.null().describe('An array of the classes on the element'),
    ])
        .describe('An array of the classes on the element')
        .optional(),
    value: z
        .union([
        z.string().min(0).max(65535).describe('The value of the element when it gained focus'),
        z.null().describe('The value of the element when it gained focus'),
    ])
        .describe('The value of the element when it gained focus'),
})
    .strict()
    .describe('{"description":"Schema for the focus of a form field","_schema_key":"iglu:com.snowplowanalytics.snowplow/focus_form/jsonschema/1-0-0","meta":{"schemaType":"event"}}');
//# sourceMappingURL=data:application/json;base64,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